export const videoKeys = {
  translation: (videoId: number, userId: number, language: string) =>
    [videoId, userId, language] as const,
  transcription: (videoId: number) => [videoId] as const,
};
